export function withShareUtm(url: string, medium: string, campaign = 'user_share'): string {
  let u: URL
  try {
    u = new URL(url)
  } catch {
    return url
  }
  if (u.protocol !== 'http:' && u.protocol !== 'https:') return url
  const params: Record<string, string> = {
    utm_source: 'goaltree',
    utm_medium: medium,
    utm_campaign: campaign,
  }
  for (const [k, v] of Object.entries(params)) if (!u.searchParams.has(k)) u.searchParams.set(k, v)
  return u.toString()
}
